export async function listExports(http) {
  const response = await http.get('/exports/list.json');
  return response.data;
}

export async function getExportMetadata(http) {
  const response = await http.get('/exports/metadata.json');
  return response.data;
}

export async function createExport(http, payload) {
  const response = await http.post('/exports', payload);
  return response.data;
}

export function downloadExport(http, exportId) {
  return http.get(`/exports/${exportId}/download`, {
    responseType: 'blob',
  });
}

export function deleteExport(http, exportId) {
  return http.delete(`/exports/${exportId}`);
}
